import { Component } from '@angular/core';

import { ModalChildComponent } from '@finder/shared/components/modal/modal-child-component.interface';

@Component({
    selector: 'finder-test-modal-child',
    template: `<p>Sonic showers fly with anomaly! Revolutionary evacuate a crew. Anomaly, voyage, and procedure.
        Starships are The Klingons of the extraterrestrial collision course.</p>
    <p>Why does the sun wobble? Paralysis at the saucer section that is when evasive queens fly.
        Girls view with resistance!</p>
    <form method="get">
        First name: <input type="text" name="fname" class="input-name"><br>
        Last name: <input type="text" name="lname" class="input-lastname"><br>
        <input type="submit" value="Submit" class="btn-submit">
    </form>
    `,
})
export class TestModalChildComponent implements ModalChildComponent {
    parentComponent;
    data;

    constructor() {
    }

}
